import { createContext, useContext } from "react";

export interface FormSubmissionContextValue {
  registerSubmit: (submitFn: () => void) => void;
  submit: () => void;
  isFormReady: boolean;
  isDirty: boolean;
  updateDirtyState: (isDirty: boolean) => void;
  forceCleanState: () => void;
  isPerformingInitialReset: boolean;
}

export const FormSubmissionContext =
  createContext<FormSubmissionContextValue | null>(null);

export const useFormSubmissionContext = (): FormSubmissionContextValue => {
  const context = useContext(FormSubmissionContext);
  if (!context) {
    throw new Error(
      "useFormSubmissionContext must be used within a FormSubmissionProvider"
    );
  }
  return context;
};
